import {
  Body1,
  Body2,
  Button,
  Image,
  Input,
  LargeTitle,
  Link,
  Text
} from '@fluentui/react-components'
import { useState, ChangeEventHandler, FC, FormEventHandler, useEffect, useRef, useLayoutEffect } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './AppDescription.module.css'

import { TeamsUserCredential } from '@microsoft/teamsfx'

import { app } from '@microsoft/teams-js'
import { getPattern, getPlaceholder } from '../DomainRules'
import sharedUrl from './sharedUrl'
import config from '../../config'

interface Props {
  domain: string
  handleDomainChange: ChangeEventHandler
  handleSubmit: FormEventHandler
  isLoggingIn: boolean
  teamsUserCredential?: TeamsUserCredential
}

export const AppDescription: FC<Props> = ({
  domain,
  handleDomainChange,
  handleSubmit,
  isLoggingIn,
  teamsUserCredential
}) => {
  const { t } = useTranslation()

  const userId =useRef("");
  const ranGet = useRef(false);
 
  const [url, setUrl] = useState(sharedUrl.getUrlFromDomain(domain));
  const [context, setContext] = useState<app.Context | null>(null);
  const [loading, setLoading] = useState(true); 

  const caretRef = useRef(0);
  const inputRef = useRef<HTMLInputElement | null>(null);
   
  const sharedBaseUrl = config.sharedUrl;

    const initializeTeams = async () => {
    try {
      await app.initialize()
      const teamsContext = await app.getContext()
      setContext(teamsContext)
      setLoading(false)

      console.log('Full Teams Context:', teamsContext)
      return teamsContext.user?.id
    } catch (error) {
      console.error('Failed to initialize Teams:', error)
      setLoading(false)
      return 'testuseronly'
    }
  }

  const enteredUrl = (e: any) => {

    const input = e.target;
    caretRef.current = input.selectionStart;

    setUrl(e.target.value)
    e.target.value = e.target.value.replace('https://', '')
    domain = e.target.value // strip off https:// as domain code expects just domain
    handleDomainChange(e) // e should now have just domain not full url
    localStorage.setItem('domain', domain)
  }

  useEffect(() => {
      if (ranGet.current) return;
      ranGet.current = true;
      
      const initialize = async () => {
          const AAD = await initializeTeams();
          const clientId = sharedUrl.getOrCreateClientId(AAD, sharedBaseUrl);
          console.log('User ID:', clientId);
          userId.current = clientId;
          console.log('Saved User ID:', userId);
          console.log('Getting url (once)');
          try {
              const response = await sharedUrl.getUrl(sharedBaseUrl + userId.current);
              if (response) {
                setUrl(response);
              }
              else {
                console.error('Null string for url');
            }
          } catch (error) {
              console.error('Error fetching string:', error);
          }
      };

    initialize()
  }, [sharedBaseUrl, teamsUserCredential])

  useLayoutEffect(() => {
      const input = inputRef.current;
      if (!input) return;

      const pos = Math.min(caretRef.current, url.length);
      input.setSelectionRange(pos, pos);
    }, [url]);


  return (
    <div className={styles.appDescription}>
      <div className={styles.title}>
        <LargeTitle className={styles.titleText}>{t('PLAN_TITLE')}</LargeTitle>
      </div>

      <Text className={styles.description}>{t('PLAN_DESCRIPTION')}</Text>

      <div className={styles.detailsContainer}>
        <Image src='boards-skeleton.png' className={styles.timesheetImage} />
        <div className={styles.descriptionBlock}>
          <Text className={styles.planDetails}>{t('PLAN_IN_TEAMS_DESCRIPTION')}</Text>

          <div className={styles.timesheetBlock}>
            <Image src='timesheet-icon.png' className={styles.timesheetIcon} />
            <Text className={styles.timesheetDetails}>{t('TIMESHEET_DESCRIPTION')}</Text>
          </div>

          <div className={styles.timesheetBlock}>
            <Image src='boards-icon.png' className={styles.timesheetIcon} />
            <Text className={styles.timesheetDetails}>{t('BOARDS_DESCRIPTION')}</Text>
          </div>

          <Body1>{t('LOGIN_DESC_LINE_1')}<br />{t('LOGIN_DESC_LINE_2')}</Body1>

          <form onSubmit={handleSubmit} className={styles.loginForm}>
            <Input
              required
              value={url}
              ref={inputRef}
              onChange={(e) => enteredUrl(e)}
              type='text'
              pattern={getPattern(true)}
              placeholder={getPlaceholder(true)}
              className={styles.inputDomain}
            />
            <Button type='submit' onClick={sharedUrl.sendUrl(url, userId, sharedBaseUrl)} disabled={isLoggingIn}>{t('LOGIN')}</Button>
          </form>
        </div>
      </div>

      <Body2 className={styles.contactUs}>
        {t('NOT_A_PLAN_CUSTOMER')}
        <Link
          href='https://www.planview.com/contact-us/'
          target='_blank'
          className={styles.link}
          rel='noreferrer'
        >
          {t('CONTACT_US')}
        </Link>
      </Body2>
    </div>
  )
}
